'use client';
import styles from './style.module.scss';
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { opacity, slideUp } from './anim';

const words = ["01","10", "20",  "30", "40", "60", "80", "100",]
// const words = ["Assalamu Alaikum","أسلم عليكم", "Te saludo",  "Ti saluto", "我向你们致敬", "Ich grüße dich", "तुम्हें सलाम करता हुँ", "selam söylüyorum",]

export default function Index() {
    const [index, setIndex] = useState(0);
    const [dimension, setDimension] = useState({width: 0, height:0});

    useEffect( () => {
        setDimension({width: window.innerWidth, height: window.innerHeight})
    }, [])

    useEffect( () => {
        if(index === words.length - 1) return;
        setTimeout( () => {
            setIndex(index + 1)
        }, index === 0 ? 1000 : 150)
    }, [index])

    const initialPath = `M0 0 L${dimension.width} 0 L${dimension.width} ${dimension.height} Q${dimension.width/2} ${dimension.height + 300} 0 ${dimension.height}  L0 0`
    const targetPath = `M0 0 L${dimension.width} 0 L${dimension.width} ${dimension.height} Q${dimension.width/2} ${dimension.height} 0 ${dimension.height}  L0 0`

    const curve = {
        initial: {
            d: initialPath,
            transition: {duration: 0.7, ease: [0.76, 0, 0.24, 1]}
        },
        exit: {
            d: targetPath,
            transition: {duration: 0.7, ease: [0.76, 0, 0.24, 1], delay: 0.3}
        }
    }

    return (
        <motion.div variants={slideUp} initial="initial" exit="exit" className={styles.introduction}>
            
            {dimension.width > 0 && 
            <>
               
                <motion.p className='font-bold ' variants={opacity} initial="initial" animate="enter"><span></span>{words[index]}%</motion.p>
                <svg>
                    <motion.path variants={curve} initial="initial" exit="exit"></motion.path>
                </svg>
            </>
            }
        </motion.div>
    )
}


// import styles from './style.module.scss';
// import { useEffect, useState } from 'react';
// import { motion } from 'framer-motion';
// import { opacity, slideUp } from './anim';

// export default function Index() {
//   const [percentage, setPercentage] = useState(1); // Start at 1
//   const [dimension, setDimension] = useState({ width: 0, height: 0 });
//   const [isVisible, setIsVisible] = useState(true); // Visibility toggle

//   useEffect(() => {
//     setDimension({ width: window.innerWidth, height: window.innerHeight });

//     // Update the percentage
//     const interval = setInterval(() => {
//       setPercentage((prev) => {
//         if (prev >= 100) {
//           clearInterval(interval);
//           setTimeout(() => setIsVisible(false), 500); // Hide after 500ms
//           return 100;
//         }
//         return prev + 1; // Increment by 1
//       });
//     }, 20); // Update every 20ms for fast progression

//     return () => clearInterval(interval); // Cleanup
//   }, []);

//   const initialPath = `M0 0 L${dimension.width} 0 L${dimension.width} ${dimension.height} Q${dimension.width / 2} ${
//     dimension.height + 300
//   } 0 ${dimension.height}  L0 0`;
//   const targetPath = `M0 0 L${dimension.width} 0 L${dimension.width} ${dimension.height} Q${dimension.width / 2} ${
//     dimension.height
//   } 0 ${dimension.height}  L0 0`;

//   const curve = {
//     initial: {
//       d: initialPath,
//       transition: { duration: 0.7, ease: [0.76, 0, 0.24, 1] },
//     },
//     exit: {
//       d: targetPath,
//       transition: { duration: 0.7, ease: [0.76, 0, 0.24, 1], delay: 0.3 },
//     },
//   };

//   return isVisible ? (
//     <motion.div variants={slideUp} initial="initial" exit="exit" className={`${styles.introduction}`}>
//       {/* Background Image */}
//       {/* <img src="/funny.jpg" alt="Background" className={styles.backgroundImage} /> */}

//       {/* Content */}
//       {dimension.width > 0 && (
//         <>
//           <motion.p className="font-bold" variants={opacity} initial="initial" animate="enter">
//             {percentage}% {/* Dynamic percentage */}
//           </motion.p>
//           <svg>
//             <motion.path variants={curve} initial="initial" exit="exit"></motion.path>
//           </svg>
//         </>
//       )}
//     </motion.div>
//   ) : null; // Render null if not visible
// }
